import * as Config from '../../configs/server.configs';

const endPoint = Config[process.env.NODE_ENV].server + '/api';

export default {
  createPaymentIntent: `${endPoint}/stripe/create-payment-intent`,
  createPaymentForRgbPackages: `${endPoint}/stripe/create-payment-for-rgb-packages`
};
